import { createSlice } from "@reduxjs/toolkit";

interface MapDataState {
    uniqueDataRedux : any[]
    MapViewVehicle: any[]
    GPSVehiclesDetails: any[]
    gridData: any[]
    markers: any[]
}

const initialState: MapDataState = {
    uniqueDataRedux: [],
    MapViewVehicle: [],
    GPSVehiclesDetails: [],
    gridData: [],
    markers: [],
}

export const MapDataSlice = createSlice({
    name: 'mapData',
    initialState,
    reducers: {
        setUniqueData: (state, action) => {
            state.uniqueDataRedux = action.payload;
        },
        setMapViewVehicle: (state, action) => {
            state.MapViewVehicle = action.payload;
        },
        setGPSVehiclesDetails : (state, action) => {
            state.GPSVehiclesDetails = action.payload;
        },
        setGridData: (state, action) => {
            state.gridData = action.payload;
        },
        setMarkers: (state, action) => {
            state.markers = action.payload;
        },
        resetState: (state) => {
            state.uniqueDataRedux = [];
            state.MapViewVehicle = [];
            state.GPSVehiclesDetails = [];
            state.gridData = [];
            state.markers = [];
        }
    },
});

export const { setUniqueData , setMapViewVehicle , setGPSVehiclesDetails , setGridData, resetState , setMarkers } = MapDataSlice.actions;
export default MapDataSlice.reducer;